import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Paper, Box, Avatar, Grid, Chip, Typography, Button, CircularProgress, Pagination , Autocomplete , TextField , MenuItem } from '@mui/material';
import ApiService from '../../functions/apiService';
import moment from 'moment-timezone';
import MyTable from '../../components/Schedule/MyTable';
import { toast } from 'react-toastify';
import AuthContext from '../../context/AuthContext';
import { Col, Row } from 'react-bootstrap';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import ButtonDatePicker from '../../components/DatePickers/ButtonDatePicker';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import ListAltIcon from '@mui/icons-material/ListAlt';
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton, Tooltip } from '@mui/material';
import Modal from 'react-bootstrap/Modal';


const ManageFreePasses = () => {
  let navigate = useNavigate();
  const { user , v3Data } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [activeTab , setActiveTab] = useState('manage-free-pass');
  const [freePasses , setFreePasses] = useState([]);
  const [deletedFreePasses , setDeletedFreePasses] = useState([]);
  const [deletedLoading, setDeletedLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const today = new Date();
  const oneMonthLater = new Date(today.getFullYear(), today.getMonth() + 1, today.getDate());
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(oneMonthLater);

  const columns = [
      {
        field: 'date', headerName: 'Date', flex: 1, minWidth: 120, valueGetter: (params) => moment(params?.row?.Shift_Date).format('MM/DD/YYYY')
      },
      {
        field: 'shift', headerName: 'Shift', flex: 1, minWidth: 130,
        renderCell: (params) => {
          const isDay = params?.row?.overtime_shift_list?.Shift_Code == 2;
          return (
            <Chip
              label={isDay ? 'Day' : 'Night'}
              size="small"
              variant="outlined"
              sx={isDay ? {
                backgroundColor: 'rgba(255, 165, 0, 0.14)',
                border: '1px solid #FF9800',
                color: '#8a5a00',
                fontWeight: 600,
                fontSize: '12px',
                borderRadius: '999px',
                width: 90,
              } : {
                backgroundColor: 'rgba(52, 152, 219, 0.10)',
                border: '1px solid #3498db',
                color: '#1a5276',
                fontWeight: 600,
                fontSize: '12px',
                borderRadius: '999px',
                width: 90,
              }}
            />
          )
        }
      },
      {
        field: 'employee', headerName: 'Employee', flex: 1, minWidth: 200, valueGetter: (params) => params?.row?.requested_emp?.fullName
      },
      {
        field: 'request', headerName: 'Request', flex: 1, minWidth: 300, valueGetter: (params) => params?.row?.Value
      },
      {
        field: 'status', headerName: 'Status', flex: 1, minWidth: 160,
        renderCell: (params) => {
          return (
            <>
              {params?.row?.Status == 'DECLINED' ?
                <Chip
                  style={{ textTransform: 'capitalize', backgroundColor: '#E627191A' }}
                  variant="outlined" color='red'
                  label={params?.row?.Status.toLowerCase()}
                />
                :
                params?.row?.Status == 'APPROVED' ?
                  <Chip
                    sx={{ backgroundColor: '#01784F1A', color: '#01784F', border: '1px solid #01784F', textTransform: 'capitalize', }}
                    variant="outlined"
                    label={params?.row?.Status.toLowerCase()}
                  />
                  :
                  <Chip
                    style={{ textTransform: 'capitalize', backgroundColor: '#FFA500', color: '#000' }}
                    label={params?.row?.Status.toLowerCase()}
                    className='requested-chip'
                  />
              }
            </>
          )
        }
      },
      {
        field: 'action', headerName: 'Action', flex: 1, minWidth: 260,
        renderCell: (params) => {
          return (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              {params?.row?.Status == 'REQUESTED' &&
                <>
                  <ButtonTheme
                    color="DarkGreen"
                    className="rounded-2"
                    onClick={() => { acceptRejectReq(params?.row, "approve") }}
                  >
                    Accept
                  </ButtonTheme>
                  <ButtonTheme
                    color="red"
                    className="rounded-2 mx-2"
                    onClick={() => acceptRejectReq(params.row, "deny")}
                  >
                    Reject
                  </ButtonTheme>
                </>
              }
              <Tooltip title="Delete">
                <IconButton
                  size="small"
                  sx={{ color: '#BF1D2D' }}
                  onClick={() => { setSelectedRow(params.row); setDeleteModal(true); }}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>
          )
        }
      },
  ]

  const deletedColumns = [
    {
      field: 'date', headerName: 'Date', flex: 1, minWidth: 120, valueGetter: (params) => moment(params?.row?.Shift_Date).format('MM/DD/YYYY')
    },
    {
      field: 'shift', headerName: 'Shift', flex: 1, minWidth: 130,
      renderCell: (params) => {
        const ol = String(params?.row?.Overtime_List);
        const isDay = ol === '2';
        const isNight = ol === '3';
        const label = isDay ? 'Day' : isNight ? 'Night' : 'Custom';
        const sx = isDay ? {
          backgroundColor: 'rgba(255, 165, 0, 0.14)',
          border: '1px solid #FF9800',
          color: '#8a5a00',
          fontWeight: 600,
          fontSize: '12px',
          borderRadius: '999px',
          width: 90,
        } : isNight ? {
          backgroundColor: 'rgba(52, 152, 219, 0.10)',
          border: '1px solid #3498db',
          color: '#1a5276',
          fontWeight: 600,
          fontSize: '12px',
          borderRadius: '999px',
          width: 90,
        } : {
          backgroundColor: 'rgba(128, 128, 128, 0.10)',
          border: '1px solid #888',
          color: '#444',
          fontWeight: 600,
          fontSize: '12px',
          borderRadius: '999px',
          width: 90,
        };
        return <Chip label={label} size="small" variant="outlined" sx={sx} />;
      }
    },
    {
      field: 'employee', headerName: 'Employee', flex: 1, minWidth: 200, valueGetter: (params) => params?.row?.requested_emp?.fullName
    },
    {
      field: 'request', headerName: 'Request', flex: 1, minWidth: 300, valueGetter: (params) => params?.row?.Value
    },
    {
      field: 'status', headerName: 'Status', flex: 1, minWidth: 160,
      renderCell: (params) => {
        return (
          <>
            {params?.row?.Status == 'DECLINED' ?
              <Chip
                style={{ textTransform: 'capitalize', backgroundColor: '#E627191A' }}
                variant="outlined" color='red'
                label={params?.row?.Status.toLowerCase()}
              />
              :
              params?.row?.Status == 'APPROVED' ?
                <Chip
                  sx={{ backgroundColor: '#01784F1A', color: '#01784F', border: '1px solid #01784F', textTransform: 'capitalize', }}
                  variant="outlined"
                  label={params?.row?.Status.toLowerCase()}
                />
                :
                <Chip
                  style={{ textTransform: 'capitalize', backgroundColor: '#FFA500', color: '#000' }}
                  label={params?.row?.Status?.toLowerCase()}
                  className='requested-chip'
                />
            }
          </>
        )
      }
    },
    {
      field: 'deleted_at', headerName: 'Deleted At', flex: 1, minWidth: 160, valueGetter: (params) => params?.row?.Delete_Time ? moment(params?.row?.Delete_Time).tz('America/New_York').format('MM/DD/YYYY hh:mm A') : '-'
    },
  ]

  const getFreePasses = () => {
    setLoading(true);
    ApiService.get(`/rfp-admin-list?start_date=${moment(startDate).format('YYYY-MM-DD')}&end_date=${moment(endDate).format('YYYY-MM-DD')}`)
      .then(({ data }) => {
        var tempArr = data?.data?.map((rfp, i) => { return { id: i + 1, ...rfp } })
        setFreePasses(tempArr)
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }

  useEffect(()=>{
    getFreePasses()
  }, [startDate , endDate])

  const getDeletedFreePasses = () => {
    setDeletedLoading(true);
    ApiService.get(`/rfp-admin-deleted-list`)
      .then(({ data }) => {
        var tempArr = data?.data?.map((rfp, i) => { return { id: i + 1, ...rfp } })
        setDeletedFreePasses(tempArr || [])
        setDeletedLoading(false);
      })
      .catch(() => {
        setDeletedLoading(false);
      });
  }

  useEffect(()=>{
    if (activeTab === 'deleted-free-passes') {
      getDeletedFreePasses()
    }
  }, [activeTab])

  const acceptRejectReq = (row, decision) => {
    ApiService.post("/request-rfp-admin-decision", {
      "Shift_Date": row.Shift_Date,
      "Shift_Code": row.overtime_shift_list?.Shift_Code,
      "Emp_Code": row.Emp_Code,
      "decision": decision,
      "batch_number": row.overtime_shift_list?.Batch_Number,
      "list": row.overtime_shift_list?.Overtime_List,
    })
      .then((data) => {
        toast.success(data?.message)
        getFreePasses()
      })
      .catch((error) => {
        toast.error(error?.data?.message)
      });
  }



  const handleDelete = () => {
    if (!selectedRow) return;
    ApiService.post('/delete-osp', {
      Shift_Date: moment(selectedRow.Shift_Date).format('YYYY-MM-DD'),
      Type: selectedRow.Type,
      Overtime_List: selectedRow.Overtime_List,
      Emp_Code: selectedRow.Emp_Code,
    })
      .then((data) => {
        toast.success(data?.message || 'Deleted successfully');
        setDeleteModal(false);
        setSelectedRow(null);
        getFreePasses();
      })
      .catch((error) => {
        toast.error(error?.data?.message || 'Failed to delete');
      });
  }

  const approvedCount = freePasses.filter(p => p.Status === 'APPROVED').length;
  const requestedCount = freePasses.filter(p => p.Status === 'REQUESTED').length;
  const declinedCount = freePasses.filter(p => p.Status === 'DECLINED').length;

  return (
    <>
      <Paper className="p-4 font-fam" style={{ marginTop: "1rem" }}>
        <Row>
          <Col style={{ paddingRight: '0px', paddingLeft: '0px', flex: '0.1', marginBottom: '10px' }}>
            <div style={{ width: '200px' }} className={activeTab == 'manage-free-pass' ? 'tab-active mx-1' : 'tab-white mx-1'}
              onClick={() => {
                setActiveTab('manage-free-pass')
                navigate('/firehouse/manage-free-passes')
              }}>
              Manage Free Passes
            </div>
          </Col>
          {(v3Data?.V3_ENABLE_DELETE_OS_PASSES == 'true' || v3Data?.V3_ENABLE_DELETE_OS_PASSES == true) &&
            <Col style={{ paddingRight: '0px', paddingLeft: '0px', flex: '0.1', marginBottom: '10px' }}>
              <div style={{ width: '200px' }} className={activeTab == 'deleted-free-passes' ? 'tab-active mx-1' : 'tab-white mx-1'}
                onClick={() => setActiveTab('deleted-free-passes')}>
                Deleted Free Passes
              </div>
            </Col>
          }
          {/* <Col style={{ paddingRight: '0px', paddingLeft: '0px', flex: '0.1', marginBottom: '10px' }}>
            <div style={{ width: '200px' }} className={activeTab == 'edit-pass' ? 'tab-active mx-1' : 'tab-white mx-1'}
              onClick={() => {
                setActiveTab('edit-pass')
                navigate('/firehouse/edit-passes')
              }}>
              Edit Passes
            </div>
          </Col> */}
        </Row>

        {activeTab === 'manage-free-pass' && (
        <>
        <Grid container spacing={2} className='mt-2'>
          <Grid item xs={12} sm={12} md={2} className='d-grid'>
            <label className='mb-1'>Start Date</label>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <ButtonDatePicker
                fullWidth
                label={startDate ? moment(startDate).format('MM/DD/YYYY') : 'MM/DD/YYYY'}
                value={startDate}
                onChange={(e) => setStartDate(e)}
              />
            </LocalizationProvider>
          </Grid>

          <Grid item xs={12} sm={12} md={2} className='d-grid'>
            <label className='mb-1'>End Date</label>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <ButtonDatePicker
                fullWidth
                label={endDate ? moment(endDate).format('MM/DD/YYYY') : 'MM/DD/YYYY'}
                value={endDate}
                onChange={(e) => setEndDate(e)}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>

        {!loading && freePasses.length > 0 && (
          <Grid container spacing={2} className='mt-3'>
            <Grid item xs={12} sm={4} md={3}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, p: 1.5, borderRadius: 2, border: '1px solid #e0e0e0', backgroundColor: '#fafafa' }}>
                <ListAltIcon sx={{ color: '#555', fontSize: 28 }} />
                <Box>
                  <Typography variant="caption" sx={{ color: '#888', display: 'block', lineHeight: 1.2 }}>Total</Typography>
                  <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.2 }}>{freePasses.length}</Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, p: 1.5, borderRadius: 2, border: '1px solid #c8e6c9', backgroundColor: '#f1f8f1' }}>
                <CheckCircleOutlineIcon sx={{ color: '#01784F', fontSize: 28 }} />
                <Box>
                  <Typography variant="caption" sx={{ color: '#888', display: 'block', lineHeight: 1.2 }}>Approved</Typography>
                  <Typography variant="h6" sx={{ fontWeight: 700, color: '#01784F', lineHeight: 1.2 }}>{approvedCount}</Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, p: 1.5, borderRadius: 2, border: '1px solid #ffe082', backgroundColor: '#fffde7' }}>
                <HourglassEmptyIcon sx={{ color: '#e65100', fontSize: 28 }} />
                <Box>
                  <Typography variant="caption" sx={{ color: '#888', display: 'block', lineHeight: 1.2 }}>Pending</Typography>
                  <Typography variant="h6" sx={{ fontWeight: 700, color: '#e65100', lineHeight: 1.2 }}>{requestedCount}</Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        )}

        {loading ?
          <Box className="w-100 h-100 d-flex justify-content-center align-items-center font-fam my-5">
            <CircularProgress />
          </Box>
          :
          <Box>
            {(!freePasses || freePasses.length == 0) ?
              <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 565 }}>
                <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                <span className='mt-4' style={{ color: '#555555' }}>
                  No Data
                </span>
              </div>
              :
              <div className='mt-4'>
                <MyTable
                  rows={freePasses}
                  columns={columns}
                  checkboxSelection={false}
                  hideFooter={freePasses.length > 100 ? false : true}
                  rowCount={freePasses.length}
                />
              </div>
            }
          </Box>
        }
        </>
        )}

        {activeTab === 'deleted-free-passes' && (
          deletedLoading ?
            <Box className="w-100 h-100 d-flex justify-content-center align-items-center font-fam my-5">
              <CircularProgress />
            </Box>
            :
            <Box className='mt-4'>
              <Box sx={{ '& .MuiDataGrid-overlay': { display: 'none' } }}>
                <MyTable
                  rows={deletedFreePasses}
                  columns={deletedColumns}
                  checkboxSelection={false}
                  hideFooter={deletedFreePasses.length > 100 ? false : true}
                  rowCount={deletedFreePasses.length}
                />
              </Box>
              {(!deletedFreePasses || deletedFreePasses.length == 0) && (
                <div className='d-flex flex-column align-items-center justify-content-center' style={{ minHeight: 400 }}>
                  <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                  <span className='mt-4' style={{ color: '#555555' }}>
                    No deleted Free passes
                  </span>
                </div>
              )}
            </Box>
        )}
      </Paper>
      <Modal show={deleteModal} size="md" onHide={() => { setDeleteModal(false); setSelectedRow(null); }}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Free Pass</Modal.Title>
        </Modal.Header>
        <Modal.Body className='px-3'>
          <Row className='mx-1'>
            Are you sure you want to delete this free pass request?
          </Row>
          <Row>
            <Col md='auto'>
              <ButtonTheme type='submit' variant="filled" color='#f5f5f5' className='mt-4' onClick={() => { setDeleteModal(false); setSelectedRow(null); }}>
                Cancel
              </ButtonTheme>
            </Col>
            <Col md='auto'>
              <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={() => handleDelete()}>
                Delete
              </ButtonTheme>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default ManageFreePasses;